// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .TrustAndVerification-confirmationLink-OtakF {
  display: inline-block;
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/trustAndVerification/TrustAndVerification.css"],"names":[],"mappings":"CAAC;EACC,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[" .confirmationLink {\n  display: inline-block;\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationLink": `TrustAndVerification-confirmationLink-OtakF`
};
module.exports = ___CSS_LOADER_EXPORT___;
